import { reactive, ref, watch } from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faAngleDown)
library.add(faAngleUp)

export default {
  components: { FontAwesomeIcon },
  name: 'FilterSelectComponent',
  props: {
    options: {
      type: Array,
      required: true,
      default: [],
    },
    placeholder: {
      type: String,
      default: 'Please select an option',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
    },
    key: {
      type: String,
    },
    permanentLabel: {
      type: Boolean,
      default: false,
    }
  },
  emits: ['selected'],
  // data () {
  //   return {
  //     options: this.options,
  //   }
  // },
  setup (props) {
    const state = reactive({
      options: ref(props.options),
      selected: ref(null),
      optionsShown: ref(false),
      filter: ref(null),
      filtered: ref(props.options),
    })

    watch(() => props.options, (options) => {
      if (options && options.length) {
        state.options = options
        state.filtered = options
      }
    })

    return { state }
  },
  methods: {
    select (option) {
      this.state.filter = null
      this.$emit('selected', option)
      // this.state.selected = option
      this.state.optionsShown = false
    },
    clear (label) {
      this.state.filter = null
      this.$emit('selected', { clear: label })
      this.state.selected = null
      this.state.optionsShown = false
    },
    toggleOptionsDisplay (event) {
      if (this.disabled) {
        return
      }
      if (this.state.optionsShown) {
        this.state.optionsShown = false
        return event.target.blur()
      }
      this.state.optionsShown = true
    },
    exit () {
      this.state.filter = null
      this.state.filtered = this.state.options
      this.state.optionsShown = false

      if (this.state.selected && !this.state.selected.id) {
        this.state.selected = {}
        this.$emit('selected', null)
      }
    },
    focus (event) {
      this.state.filtered = this.state.options
      // this.state.optionsShown = true
    },
    filter (event) {
      const filter = event.target.value
      if (27 === event.keyCode) {
        event.target.blur()
        return
      }
      this.state.filter = filter
      this.state.selected = { name: filter }
      if (filter) {
        const filtered = this.state.options.filter(option => {
          if (option.name) {
            return option.name.toLowerCase().includes(
              filter.toLowerCase())
          }
          if (option.label) {
            return option.label.toLowerCase().includes(
              filter.toLowerCase())
          }
        })
        if (filtered.length) {
          this.state.filtered = filtered
          return
        }
        this.state.filter = null
        this.state.filtered = [
          {
            id: -1,
            name: 'No Results Found',
          },
        ]
        return
      }
      this.state.selected = {}
      this.state.filtered = this.state.options
    },
  },
}
